/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React,{useState} from 'react'
import { Link } from 'react-router-dom';
import { CDN } from '../../constants';
import { WishlistExist } from '../../redux/helper/AddWishlist';
import { ExpectedDateGenerator } from '../../redux/helper/DateConverter';
import CategoryToolTip from '../CategoryToolTip';

function ProductCard({prod,
    type,
    STOCK_VISIBILITY,
    handleCrud,
    selectedWishlist,
    setshow,
    setselectedItem,
    wishlistProduct,
    setCartId,
    setaddtocartPopup,
    Cart,
    CartId}) {
    const profile = JSON.parse(localStorage.getItem('user'))?.profile
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    const [hoverId, sethoverId] = useState('');

    const handleIconImage = (wishlistProduct,prod)=>{
        let img=''
        if(WishlistExist(wishlistProduct,prod.INVENTORY_ITEM_ID)){
            img='heart_active.svg'
        }else{
            img='Iconawesome-heart.svg'
        }
        return img
    }
    return (
        <div className="rounded-lg bg-[#FFFFFF] shadow-s7 pt-2 sm:pb-2.5 pb-2 sm:pl-3 sm:pr-4 px-2.5 relative">
            <div className="flex flex-wrap">
                <div className="lg:w-[65%] w-full pt-2">
                    <div className="flex">
                        <div className="w-1/4">
                            <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}>
                                <motion.img initial={{ opacity: 0, scale: 0.6 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{
                                        duration: 0.8,
                                        delay: 0.5,
                                        ease: [0, 0.71, 0.2, 1.01]
                                    }} src={handleImage(prod?.IMAGE_NAME)} alt="icon" className="w-full" />
                            </Link>
                        </div>
                        <div className="pl-2.5">
                            <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}>
                                <div>
                                    <p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0,20)}...`:`${prod.DESCRIPTION}`}`}<span className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit ml-2.5">{prod?.MAIN_CATEGORY}</span></p>
                                </div>
                            </Link>
                            <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><span>Product Code: {prod?.CONCATENATED_SEGMENTS}</span><span className="sm:px-4 px-2">|</span>{prod?.AWS_CLASSIFICATION === null ? null :<span>AWS Classification: {prod?.AWS_CLASSIFICATION}</span>}</p>
                            <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                <div className="flex sm:border-r sm:border-[#707070] sm:pr-2.5 w-fit items-center" onMouseEnter={()=>sethoverId(prod.INVENTORY_ITEM_ID)} onMouseLeave={()=>{
                                    setTimeout(() => {
                                        sethoverId('')
                                    }, 1000);
                                }}>
                                    <p className="text-xs font-semibold text-[090406]">Category</p>
                                    <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{prod?.DELIVERY_LEAD_TIME}</p>
                                    <img src="/images/info_icon1.svg" alt="icon" className="cursor-pointer w-[12px]" />
                                    {hoverId=== prod.INVENTORY_ITEM_ID &&(
                                        <CategoryToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID}/>
                                    )}
                                </div>
                                <p className="text-xs font-semibold text-[#808285] sm:px-2 sm:border-[#707070] sm:pt-0 pt-1">Expected Dispatch: <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME):'-'}</span></p>
                                {/* <p className="text-xs font-semibold text-[#808285] sm:pl-2 sm:pt-0 pt-1">Expected Delivery: <span className="font-bold text-[#555259]">24/06/2022</span></p> */}
                            </div>
                            <p className="text-xs font-semibold text-[#808285] sm:mt-2 mt-1">Method of Packing: <span className="text-[#555259]">{prod?.METHOD_OF_PACKING}</span></p>
                        </div>
                    </div> 
                    <div className="lg:w-[70%] w-full sm:pl-4">
                        <p className="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">{prod?.DESCRIPTION}</p>
                    </div>
                </div>
                <div className="lg:w-[35%] w-full lg:pt-0 pt-5">
                                        
                    <div className="flex justify-end w-full lg:pr-10 pr-0">
                        <p className={`sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] px-2.5 py-[7px] w-fit ${profile?.PRIVILAGES.includes('stock_visibility')?'':'opacity-0'}`}>Stock :  {STOCK_VISIBILITY ? <span className="text-[#424446] font-semibold">{prod?.STOCK_ONHAND_QTY} <>{prod?.PRIMARY_UOM_CODE}</></span>:0}</p>
                    </div>
                    
                    <div>
                        <div className="bg-[#EAEAF0] rounded-md p-4 w-full mt-1.5">
                            <div className="flex">
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Unit of Measurement</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.PRIMARY_UOM_CODE}</p>
                                </div>
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Minimum Order Quantity</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY || 1}</p>
                                </div>
                            </div>
                            <div className="flex pt-4">
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Standard Pack Size</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                        {prod?.PACKING_SIZE || 1} {prod?.PRIMARY_UOM_CODE}</p>
                                </div>
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Size</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                        <>
                                            <>{`${prod.DIAMETER!==null ?`${prod.DIAMETER}mm`:''}`}</>
                                            <>{`${prod.LENGTH!==null && prod.DIAMETER ? 'x':''}`}</>
                                            <>{`${prod.LENGTH!==null ?`${prod.LENGTH}mm`:''}`}</>
                                            <>{prod.LENGTH===null && prod.DIAMETER===null ? '-':''}</>
                                        </>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-2.5 flex items-center">
                <div className="lg:w-[65%] w-full pl-4">
                    <p className="sm:text-xs6 text-xs2 font-semibold text-[#808285]">List Price</p>
                    <p className="md:text-xs11 sm:text-xl text-lg font-semibold text-[#15090E]">{Number(prod?.LIST_PRICE)?.toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    })}</p>
                </div>
                <div className="lg:w-[35%] w-full">
                    <button type="button" 
                        onClick={()=>{
                            if(type !=='wishlist'){
                                setCartId(prod)
                            }else{
                                setaddtocartPopup(prod.item_id)
                            }
                        }}
                        className="w-full sm:h-10 h-8 rounded-lg bg-[#555259] text-sm font-semibold text-[#FFFFFF]"
                        data-bs-toggle="modal" data-bs-target="#addtocart">
                        {type =='wishlist'? 'Add to Cart':<>{WishlistExist(Cart,prod.INVENTORY_ITEM_ID)?'Added to Cart!':'Add to Cart'}</>}
                    </button>
                </div>
            </div>
            <button type="button" className="removefromlist">
                <img src={`/images/${type!=='wishlist'?handleIconImage(wishlistProduct,prod):'Icon-feather-trash-2.svg'}`} alt="icon" className="absolute top-4 right-[22px] cursor-pointer" onClick={()=>{
                    if(type==='productlist'){
                        setshow('popup');
                        setselectedItem(prod)
                    }else{
                        handleCrud(prod,selectedWishlist.collection_id,'remove')
                    }
                }}/>
            </button>
             
        </div>
    )
}

export default ProductCard